export default function IconSmallSeat({ className: _className }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 24"
            fill="currentColor"
        >
            <path
                d="M19 9.857v-3a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v3m14 0a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2m0-9a2 2 0 0 0-2 2v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-1.5a2 2 0 0 0-2-2m0 0a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2m0 0h14m-14 0v2m14-2v2"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fillRule="evenodd"
            />
        </svg>
    );
}
